import { render } from "./TreeGrid.vue?vue&type=template&id=8567820a&scoped=true&ts=true"
import script from "./TreeGrid.vue?vue&type=script&lang=ts"
export * from "./TreeGrid.vue?vue&type=script&lang=ts"

import "./TreeGrid.vue?vue&type=style&index=0&id=8567820a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8567820a"]])

export default __exports__